export interface IEcommerceProduct {
	active?: string;
	product_name?: string;
	product_desc?: string;
	product_price?: number;
	product_short_desc?: string;
	sku?: string;
	subscription_only?: boolean;
}
